import { z } from 'zod'
import { accountTotalResponseSchema } from './account-total-response.schema'

const expenseSourceSchema = z.object({
  type: z.literal('EXPENSE'),
  // Expense.description is nullable in the DB; the API has always emitted null here
  // for description-less expenses — the schema now matches that reality
  description: z.string().nullable(),
  categoryName: z.string(),
  amount: z.number(),
})

const incomeSourceSchema = z.object({
  type: z.literal('INCOME'),
  description: z.string().nullable(),
  categoryName: z.string(),
  amount: z.number(),
})

const transferSourceSchema = z.object({
  type: z.literal('TRANSFER'),
  fromAccountName: z.string(),
  toAccountName: z.string(),
  amount: z.number(),
  convertedAmount: z.number().nullable(),
})

const manualSourceSchema = z.object({
  type: z.literal('MANUAL'),
})

export const sourceDetailsSchema = z.discriminatedUnion('type', [
  expenseSourceSchema,
  incomeSourceSchema,
  transferSourceSchema,
  manualSourceSchema,
])

export type SourceDetailsDto = z.infer<typeof sourceDetailsSchema>

export const enrichedAccountTotalResponseSchema = accountTotalResponseSchema.extend({
  sourceDetails: sourceDetailsSchema.nullable(),
})

export type EnrichedAccountTotalResponseDto = z.infer<typeof enrichedAccountTotalResponseSchema>
